import React from 'react';
import { Grid } from 'semantic-ui-react';
import { InputWithLabelWrapper } from 'react-lib/dist/components-es';

class GridColumnInputWrapper extends React.Component {
  render() {
    const { width } = this.props;

    return (
      <Grid.Column width={width}>
        <InputWithLabelWrapper {...this.props} />
      </Grid.Column>
    );
  }
}

export default GridColumnInputWrapper;
